module.exports = __webpack_public_path__ + "static/img/course_background.ffb7b51.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/course_background.png
// module id = iPx2
// module chunks = 0